module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cp_gaseosas_lata_354_schw_pomelo.1fcffde4.png";